'use strict';

import Swiper from 'swiper';

const SELECTOR = '.js-scroller';

export function initialiseElement(element, options = {}) {
    const scrollerElement = element.querySelector('.swiper-container');

    const mq = window.matchMedia('(max-width: 800px)');

    let scroller;

    const defaults = {
        slidesPerView: 'auto',
        freeMode: true,
        simulateTouch: false,
        mousewheel: {
            releaseOnEdges: true,
            forceToAxis: true,
            invert: true,
            sensitivity: .8
        },
        navigation: {
            nextEl: element.querySelector('.scroller-next'),
            prevEl: element.querySelector('.scroller-prev')
        },
    };

    const settings = {
        ...defaults,
        ...options,
        mousewheel: { ...defaults.mousewheel, ...options.mousewheel },
        navigation: { ...defaults.navigation, ...options.navigation },
    };

    if (!mq.matches) {
        scroller = new Swiper( scrollerElement, settings );
    }

    function loadScroller(event) {
        if (event.matches) {
            scroller.destroy( true, true );
        } else {
            scroller = new Swiper( scrollerElement, settings );
        }
    }

    mq.addListener(loadScroller);

    return scroller;
}

export function init() {
    document.querySelectorAll(SELECTOR).forEach(initialiseElement);
}
